import { Box, ColorOptions, convertHexToRGBA, Icon, MaterialTextInput, MaterialTextInputProps } from '@jfs/ui-new'
import React, { useEffect, useState } from 'react'
import { MerchantTheme } from '../../data/models/Config'
import { Validations } from '../../data/models/JioPayFinanceHub'
import { TollTip } from '../TextInputToolTip/TollTip'

interface AepsTextInputProps extends MaterialTextInputProps {
  textType?: 'nameWithSpace' | 'captialize' | 'numOnly'
  validations: Array<typeof Validations.properties>
  theme: typeof MerchantTheme.properties
  infoText: string
}

export const PGTextInput = ({ textType, validations, theme, infoText, ...props }: AepsTextInputProps) => {
  const [error, setTextError] = React.useState(props.error)
  const [toolTipVisibility, setToolTipVisibility] = useState(false)
  const isValid = (value: string) => {
    let isError = false
    validations.forEach(({ validationPattern, errorMessage, label }: any) => {
      if (validationPattern === '>=' && !(+value >= +label)) {
        console.log('1')
        isError = true
      } else if (validationPattern === '<=' && !(+value <= +label)) {
        console.log('validationPattern', validationPattern)
        console.log('props.value?.value', value)
        console.log('label', label)
        console.log('validationPattern', +value <= +label)
        console.log('2')
        isError = true
      } else if (
        !(validationPattern === '<=' || validationPattern === '>=') &&
        !new RegExp(validationPattern).test(value)
      ) {
        console.log('3')
        isError = true
      }
    })
    return !isError
  }

  useEffect(() => {
    props?.setFieldValue(props?.fieldName, { value: props.value?.value, isValid: isValid(props.value?.value) })
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])
  return (
    <>
      <MaterialTextInput
        placeholderTextColor={convertHexToRGBA(theme?.bodyTextColor, 50) as ColorOptions}
        color={theme?.bodyTextColor as any}
        bottomLineColor={theme?.brandColor as any}
        tintColor={theme?.brandColor as any}
        onFocusBottomLineColor={theme?.brandColor as any}
        selectionColor={theme?.brandColor as any}
        {...props}
        value={props.value?.value}
        error={error}
        onChange={(text: string) => {
          if (textType === 'nameWithSpace') {
            if (text.trim().length === 0) {
              text = text.trim()
            } else if (
              ['  ', '..', "''", ".'", '. ', "' ", "'.", ' .', " '"].includes(text.slice(-2)) ||
              !text.match(/^[a-zA-Z]+(\s{0,1}[a-zA-Z'. ])*$/)
            ) {
              text = text.slice(0, text.length - 1)
            }
          } else if (textType === 'captialize') {
            text = text.toUpperCase()
          } else if (textType === 'numOnly' && !/^\d+$/.test(text)) {
            text = text.slice(0, text.length - 1)
          }

          props.onChange?.call(this, text)
          props.setFieldValue(props?.fieldName, { value: text, isValid: isValid(text) })
        }}
        onBlur={() => {
          let textError = ''
          validations.forEach(({ validationPattern, errorMessage, label }: any) => {
            if (validationPattern === '>=' && !(+(props.value?.value as any) >= +label)) {
              textError = errorMessage
            } else if (validationPattern === '<=' && !(+(props.value?.value as any) <= +label)) {
              textError = errorMessage
            } else if (
              !(validationPattern === '<=' || validationPattern === '>=') &&
              !new RegExp(validationPattern).test(props.value?.value as any)
            ) {
              textError = errorMessage
            }
          })
          setTextError(textError)
        }}
        rightComponent={
          infoText?.trim() !== '' && (
            <Box
              underlayColor={'TRANSPARENT'}
              onPress={() => setToolTipVisibility(true)}
              onHover={(value: boolean) => {
                setToolTipVisibility(value)
              }}>
              <Icon color={theme?.brandColor as any} id="INFO" size={19} />
            </Box>
          )
        }
      />
      <TollTip visible={toolTipVisibility} msg={infoText} />
    </>
  )
}
